exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#StdAttribute[data-v-877b61ec] .el-input-number.is-without-controls .el-input__inner{text-align:left}", ""]);

// exports
